import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.accountEdit.replace(appPath.account, ''),
	components: () => [import(/* webpackChunkName: 'memberEdit' */ './component')],
	render: ([MemberEdit]) => <MemberEdit />,
};

export default routes;
